import { useEffect,useState, useRef } from "react";
import { DataTable, DataTableRowEditCompleteEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { SubDistrictModel } from "../../models/subDistrict-model";
import { Button } from "primereact/button";
import { Toast, ToastMessage } from "primereact/toast";
import UserAddressService from "../../services/useraddress/useraddress.service";
 
interface DataTableProps {
  data: any[];
  NoofRecords: number;
  pageNumber: number;
  pageSize: number;
  searchTerm: any;
  onPageChange: any;
  onDataUpdate:(updatedData:any[])=> void;
  fetchData: (pageNumber: number, pageSize: number) => void;
}
 
const SubdistrictDataTable: React.FC<DataTableProps> = (props) => {
  const [data, setData] = useState<any[]>([]);
  const toast = useRef<Toast>(null);
  const [selectedSubdistrict, setSelectedSubdistrict] = useState<any>(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
 
  useEffect(() => {
    setData(props.data);
  }, [props.data]);
 
  const showMessage = (
    label: string,
    message: string,
    severity: ToastMessage["severity"]
  ) => {
    toast.current?.show({
      severity,
      summary: label,
      detail: message,
      life: 3000,
    });
  };
 
const subdistrictEditor = (options: ColumnEditorOptions) => {
    return (
        <InputText
            type="text"
            value={options.value}
            style={{ width: "95%", border: "1px solid #090" }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                options.editorCallback!(e.target.value)
            }
        />
    );
};
const onRowEditComplete = async (event: DataTableRowEditCompleteEvent) => {
  const { newData, index } = event;
  const _data = [...data];
 
    if (!newData.subDistrictName || newData.subDistrictName.trim() === '') {
      showMessage("Warning", "Please provide the subdistrict name", "warn");
      return;
    }
 
  if (_data[index] !== newData) {
    let putData = {
      subDistrictId: newData.subDistrictId,
      subDistrictName: newData.subDistrictName
    };
    try {
      const response = await UserAddressService.UpdateSubdistrict(putData);
      _data[index] = newData;
      setData(_data);
      if (response.isSuccess) {
        showMessage("Success", response.message, "success");
      } else {
        showMessage("Error", response.message || "This subdistrict already exists", "error");
      }
       props.fetchData(props.pageNumber, props.pageSize);
    } catch (err) {
      showMessage("Error", "Update failed", "error");
    }
  }
};
const onHideDeleteDialog = () => {
  setShowDeleteDialog(false);
  setSelectedSubdistrict(null);
};
 
const deleteSubdistrict = async () => {
  try {
    const response = await UserAddressService.deleteSubdistrict(selectedSubdistrict.subDistrictId);
    if (response.isSuccess) {
      showMessage("Success", response.message, "success");
    } else {
      showMessage("Error", response.message || "Delete failed", "error");
    }
    props.fetchData(props.pageNumber, props.pageSize);
  } catch (err) {
    showMessage("Error", "Delete failed", "error");
  } finally {
    onHideDeleteDialog();
  }
};
 
    const deleteTemplate = (rowData: SubDistrictModel) => {
        return (
            <Button
                icon="pi pi-trash"
                onClick={() => confirmDelete(rowData)}
                style={{ border: 'none', color: 'gray', background: 'none' }}
                className="p-button-rounded"
            />
        );
    };
 
    const confirmDelete = (rowData: SubDistrictModel) => {
      setSelectedSubdistrict(rowData);
      setShowDeleteDialog(true);
  };
 
  return (
    <div className="col-12">
     <Toast ref={toast} />
      <div className="card border-noround p-2">
        <DataTable
          value={props.data}
          paginator
          editMode="row"
          rows={props.pageSize}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          totalRecords={props.NoofRecords}  
          lazy={true}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate={`{first} to {last} of ` + props.NoofRecords}
          first={(props.pageNumber - 1) * props.pageSize}
          onPage={props.onPageChange}
          onRowEditComplete={onRowEditComplete}
        >
          <Column field="subDistrictName" header="Subdistrict" editor={subdistrictEditor} style={{ width: "18%" }} className="pl-6" />
          <Column field="districtName" header="District" style={{ width: "25%" }} />
          <Column rowEditor header="Action" style={{ width: "5%" }}/>
          <Column body={deleteTemplate} header="Delete" style={{ width: "5%" }}/>
        </DataTable>
      </div>
      <Dialog
        visible={showDeleteDialog}
        header="Confirm Delete"
        modal
        onHide={onHideDeleteDialog}
        footer={
          <div>
            <Button label="Yes" icon="pi pi-check" className="p-button-danger" onClick={deleteSubdistrict} />
          </div>
        }
      >
        <div className="confirmation-content">
          {selectedSubdistrict && (
            <span>
              Are you sure you want to delete <strong>{selectedSubdistrict.subDistrictName}</strong>?
            </span>
          )}
        </div>
      </Dialog>
    </div>
  );
};
 
export default SubdistrictDataTable;